import { render, staticRenderFns } from "./HeaderSubsection.vue?vue&type=template&id=54c7fbeb&scoped=true"
import script from "./HeaderSubsection.vue?vue&type=script&lang=js"
export * from "./HeaderSubsection.vue?vue&type=script&lang=js"
import style0 from "./HeaderSubsection.vue?vue&type=style&index=0&id=54c7fbeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7fbeb",
  null
  
)

export default component.exports